import React from 'react';
import { Form, Button } from 'semantic-ui-react';
import { node, bool, object } from 'prop-types';

// DO NOT ADD SPECIFIC QA TAG HERE: this component is reused in other forms
const SubmitButton = ({ submitting, disabled, qa, ...props }) => (
  <Form.Field
    {...qa}
    type="submit"
    control={Button}
    size="tiny"
    primary
    loading={submitting}
    disabled={disabled}
    {...props}
  >
    {props.children}
  </Form.Field>
);

SubmitButton.propTypes = {
  children: node.isRequired,
  submitting: bool,
  disabled: bool,
  qa: object
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/FormComponents/SubmitButton.js